


import React from "react";
import { useTranslation } from "react-i18next";
import serviceImg from "../../images/about07.jpeg";

const AboutService = () => {
  const { t, i18n } = useTranslation();

  return (
    <section
      className="mahal-service-section mb-5 pb-80"
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
    >
      <div className="container">
        <div className="row align-items-center">

          {/* LEFT IMAGE */}
          <div className="col-lg-5 mb-4 mb-lg-0">
            <div className="mahal-service-image">
              <img src={serviceImg} alt="MAHAL Services" />
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="col-lg-7">
            <div className="mahal-service-content">




              {/* ================= Heading ================= */}
              <h2 className="mahal-title23">

                <div className="heading-line1">
                  <span className="title32-text">
                    {t("aboutServiceContent.title1")}
                  </span>
                </div>

                <div className="heading-line2">
                  <span className="from-text">
                    {t("aboutServiceContent.from")}
                  </span>

                  <span className="trusted-text">
                    {t("aboutServiceContent.highlight")}
                  </span>
                </div>

              </h2>

              <p className="mahal-desc">
                {t("aboutServiceContent.desc")}
              </p>

              <p className="mahal-text">
                {t("aboutServiceContent.text")}
              </p>
              <div className="about-feature-grid">

                {/* 24/7 Scheduled Delivery */}
                <div className="about-feature-card">

                  <div className="about-feature-icon">
                    <svg viewBox="0 0 24 24" fill="none">

                      <rect
                        x="2.5"
                        y="7"
                        width="11"
                        height="8"
                        rx="2"
                        stroke="currentColor"
                        strokeWidth="1.8"
                      />

                      <path
                        d="M13.5 9H17L20 12V15H13.5"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />

                      <circle
                        cx="7"
                        cy="18"
                        r="1.7"
                        stroke="currentColor"
                        strokeWidth="1.8"
                      />

                      <circle
                        cx="17"
                        cy="18"
                        r="1.7"
                        stroke="currentColor"
                        strokeWidth="1.8"
                      />

                    </svg>
                  </div>

                  <div className="about-feature-text">
                    <h5>{t("aboutServiceContent.f1")}</h5>
                  </div>

                </div>



                {/* Expert Supplier Network */}
                <div className="about-feature-card">

                  <div className="about-feature-icon">
                    <svg viewBox="0 0 24 24" fill="none">

                      <circle
                        cx="12"
                        cy="7"
                        r="3"
                        stroke="currentColor"
                        strokeWidth="1.8"
                      />

                      <path
                        d="M5 19C5 16.2 8 14.5 12 14.5C16 14.5 19 16.2 19 19"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                      />

                      <path
                        d="M4 8L2.5 9.5"
                        stroke="currentColor"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                      />

                      <path
                        d="M20 8L21.5 9.5"
                        stroke="currentColor"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                      />

                    </svg>
                  </div>

                  <div className="about-feature-text">
                    <h5>{t("aboutServiceContent.f2")}</h5>
                  </div>

                </div>



                {/* Quality Assured Products */}
                <div className="about-feature-card">

                  <div className="about-feature-icon">
                    <svg viewBox="0 0 24 24" fill="none">

                      <path
                        d="M12 2L19 5V10C19 15 16 19 12 21C8 19 5 15 5 10V5L12 2Z"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinejoin="round"
                      />

                      <path
                        d="M9 12L11 14L15 10"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />

                    </svg>
                  </div>

                  <div className="about-feature-text">
                    <h5>{t("aboutServiceContent.f3")}</h5>
                  </div>

                </div>



                {/* Wide Product Availability */}
                <div className="about-feature-card">

                  <div className="about-feature-icon">
                    <svg viewBox="0 0 24 24" fill="none">

                      <rect
                        x="4"
                        y="5"
                        width="16"
                        height="14"
                        rx="2"
                        stroke="currentColor"
                        strokeWidth="1.8"
                      />

                      <path
                        d="M8 9H16"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                      />

                      <path
                        d="M8 13H13"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                      />

                      <circle
                        cx="17"
                        cy="15.5"
                        r="1"
                        fill="currentColor"
                      />

                    </svg>
                  </div>

                  <div className="about-feature-text">
                    <h5>{t("aboutServiceContent.f4")}</h5>
                  </div>

                </div>

              </div>

              <div className="mahal-btn-group mt-5">
                <a href="/Registration" className="mahal-btn-primary">
                  {t("aboutServiceContent.cta1")}
                </a>
                <a href="/contact" className="mahal-btn-secondary">
                  {t("aboutServiceContent.cta2")}
                </a>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutService;